export default "__VITE_ASSET__8ffe4ac1__"